import { Button } from '@mui/material';
import PropTypes from 'prop-types';

export const tableColumns = (
  handleOpenDetailsEmployment,
  handleOpenDeleteEmployment
) => [
  {
    accessorKey: 'organizationName',
    header: 'Organization Name',
    enableSorting: true,
    filterVariant: 'textField',
    enableColumnFilter: true,
  },
  {
    accessorKey: 'userName',
    header: 'User Fullname',
    enableSorting: true,
    filterVariant: 'textField',
    enableColumnFilter: true,
  },
  {
    accessorKey: 'username',
    header: 'Username',
    enableSorting: true,
    filterVariant: 'textField',
    enableColumnFilter: true,
  },
  {
    accessorKey: 'userType',
    header: 'User Type',
    enableSorting: true,
    filterVariant: 'textField',
    enableColumnFilter: true,
  },
  {
    accessorKey: 'isOwner',
    header: 'Is Owner',
    enableSorting: true,
    filterVariant: 'textField',
    enableColumnFilter: true,
  },
  {
    accessorKey: 'details',
    header: 'Details',
    enableSorting: false,
    enableColumnFilter: false,
    enableFacetedValues: false,
    Cell: ({ renderedCellValue }) => {
      return detailsCell({ renderedCellValue, handleOpenDetailsEmployment });
    },
  },
  {
    accessorKey: 'delete',
    header: 'Delete',
    enableSorting: false,
    enableColumnFilter: false,
    enableFacetedValues: false,
    Cell: ({ renderedCellValue }) => {
      return deleteCell({ renderedCellValue, handleOpenDeleteEmployment });
    },
  },
];

//! Language
const detailsCell = ({ renderedCellValue, handleOpenDetailsEmployment }) => {
  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          handleOpenDetailsEmployment(renderedCellValue);
        }}>
        Details
      </Button>
    </div>
  );
};

detailsCell.propTypes = {
  renderedCellValue: PropTypes.object.isRequired,
  handleOpenDetailsEmployment: PropTypes.func.isRequired,
};

const deleteCell = ({ renderedCellValue, handleOpenDeleteEmployment }) => {
  return (
    <div>
      <Button
        variant="contained"
        color="secondary"
        onClick={() => {
          handleOpenDeleteEmployment(renderedCellValue);
        }}>
        Delete
      </Button>
    </div>
  );
};

deleteCell.propTypes = {
  renderedCellValue: PropTypes.object.isRequired,
  handleOpenDeleteEmployment: PropTypes.func.isRequired,
};
